import React from "react";
import "../styles/pages/privacypolicy.css";
import SubHome from "../components/SubHome";

const EaterOnCheffy = () => {
  return (
    <>
      <SubHome mainHeading="Eater en Cheffy" listItem="Eater en Cheffy" />
      <div className="privacy-policy-container">
        <div
          className="heading-content-section"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 className="main-heading">Cómo Convertirte en Eater en Cheffy</h2>
          <div
            className="heading-border"
            style={{ marginBottom: "40px" }}
          ></div>
        </div>

        <p>
            ¡Descubre una nueva forma de disfrutar comidas deliciosas,
            preparadas por chefs, en la comodidad de tu hogar con Cheffy!
            Convertirte en Eater es fácil y te abre las puertas a experiencias
            gastronómicas personalizadas y de alta calidad, todo a precios
            accesibles. Así es como puedes comenzar:
          </p>
          <ol>
            <li>
              <strong>Descarga la App de Cheffy:</strong> Comienza descargando
              nuestra aplicación, disponible para iOS y Android, para explorar
              un mundo de opciones culinarias diseñadas especialmente para ti.
            </li>
            <br />
            <li>
              <strong>Crea Tu Perfil:</strong> Configura tus preferencias para
              ayudar a los chefs a conocer tus gustos. Ya sea que tengas antojo
              de un banquete gourmet, sabores locales, opciones de meal prep o
              platillos para llenar tus tuppers de la semana, hay chefs listos
              para crear lo que deseas.
            </li>
            <br />
            <li>
              <strong>Publica Tu Solicitud de Comida:</strong> ¡Lanza tu oferta! Describe qué
              estás buscando, fija tu presupuesto y deja que chefs talentosos
              pujen para hacer realidad tu visión. Tendrás la libertad de elegir
              un chef según las reseñas, especialidades y precio, asegurándote
              de obtener la comida perfecta al mejor valor.
            </li>
            <br />
          
           
          </ol>
      </div>
    </>
  );
};

export default EaterOnCheffy;
